export const SET_LIVE_PROP = 'SET_LIVE_PROP';
export const CLEAR_LIVE_PROPS = 'CLEAR_LIVE_PROPS';
export const GENERATE_ENERGY_MONITORING_STATS = 'GENERATE_ENERGY_MONITORING_STATS';
export const SET_ENERGY_MONITORING_STATS = 'SET_ENERGY_MONITORING_STATS';
export const SET_LIVE_MODE = 'SET_LIVE_MODE';
